import type { ReactNode } from 'react';
import { back, navigate } from '../lib/router';
import { DESKTOP, useMedia } from '../lib/useMedia';
import { IconButton } from './Button';
import s from './Page.module.css';

/** Layout for tab screens and settings: a big title, optional actions, then content. */
export function Page({
  title,
  children,
  actions,
  backTo,
  wide,
}: {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  /** Shows a back button (for pushed screens like Settings). */
  backTo?: string;
  wide?: boolean;
}) {
  const desktop = useMedia(DESKTOP);
  return (
    <div className={`${s.page} ${wide ? s.wide : ''}`}>
      <header className={s.header}>
        {/* Back arrow and title share one line. */}
        <div className={s.titleRow}>
          {backTo && !desktop && (
            <IconButton icon="arrow-left" label="Back" onClick={() => back(backTo)} />
          )}
          <h1 className="t-title1">{title}</h1>
        </div>
        <div className={s.actions}>
          {actions}
          {!desktop && !backTo && (
            <IconButton icon="gear-six" label="Settings" onClick={() => navigate('/settings')} />
          )}
        </div>
      </header>
      <div className={s.body}>{children}</div>
    </div>
  );
}
